module.exports = __webpack_public_path__ + "static/media/blog2.d0a43bd1.jpg";